@switch (modalProps?.name) {
	@case ("open-privacy") {
		<app-modal-wrap
			(onClose)="modalProps = null; continueSteps()"
			title="privacy"
			modalWrapperClass="modal-800"
		>
			<app-open-privacy (onClose)="modalProps = null; continueSteps()" />
		</app-modal-wrap>
	}
	@case ("open-instructions") {
		<app-modal-wrap
			(onClose)="modalProps = null; continueSteps()"
			title="instruction_suggest"
			modalWrapperClass="confirm-modal-vert-center modal-narrow-width"
		>
			<app-open-instructions (onClose)="modalProps = null; continueSteps()" />
		</app-modal-wrap>
	}
	@case ("ita-get-auth") {
		<app-modal-wrap
			(onClose)="modalProps = null; continueSteps()"
			title="ita_get_auth"
			modalWrapperClass="modal-650"
		>
			<app-ita-get-auth (onClose)="modalProps = null; continueSteps()" />
		</app-modal-wrap>
	}
	@case ("task") {
		<app-modal-wrap
			(onClose)="modalProps = null; continueSteps()"
			modalWrapperClass="modal-650"
			title="tasks"
		>
			<app-task (onClose)="modalProps = null; continueSteps()" />
		</app-modal-wrap>
	}
	@case ("confirm-payment") {
		<app-modal-wrap
			(onClose)="modalProps = null; continueSteps()"
			title="payment_request"
			modalWrapperClass="confirm-modal-vert-center modal-narrow-width"
		>
			<app-confirm
				(onClose)="
					modalProps = null;
					$event && router.navigateByUrl('/purchases/create');
					continueSteps()
				"
				confirmText="to_payment"
				[freeText]="modalProps.freeText"
				avoidCancel
			>
				<button
					class="btn btn-default"
					(click)="isErrorOpen = true"
				>
					{{ "contact_us" | langVal }}
				</button>
				@if (isErrorOpen) {
					<app-modal-wrap
						(onClose)="isErrorOpen = false; modalProps = null; continueSteps()"
						modalWrapperClass="modal-650"
						title="how_can_we_help"
					>
						<app-error
							(onClose)="
								isErrorOpen = false; modalProps = null; continueSteps()
							"
						/>
					</app-modal-wrap>
				}
			</app-confirm>
		</app-modal-wrap>
	}
	@case ("confirm-partner") {
		<app-modal-wrap
			(onClose)="modalProps = null; continueSteps()"
			title="confirm_partnership"
			modalWrapperClass="confirm-modal-vert-center modal-narrow-width"
		>
			<app-confirm
				(onClose)="$event && acceptPartner(); continueSteps()"
				confirmText="confirm"
				[freeText]="'i_confirm_partnership' | langVal"
			/>
		</app-modal-wrap>
	}
	@case ("otp") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="otp"
			modalWrapperClass="modal-fit-content"
		>
			<app-otp
				(onClose)="modalProps = null"
				mode="otp"
			/>
		</app-modal-wrap>
	}
	@case ("confirm-ita") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="get-israel_invoice"
			modalWrapperClass="confirm-modal-vert-center modal-narrow-width"
		>
			<app-confirm
				(onClose)="modalProps = null"
				avoidCancel
				[freeText]="modalProps.freeText | langVal"
				confirmText="continue"
			/>
		</app-modal-wrap>
	}
}
